import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_PROGRAM_EDIT_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_PROGRAM_EDIT_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_PROGRAM_EDIT_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/user-programs/${id}`,
    method: 'PATCH',
    body: payload,
    notify: true,
  })
);

export default apiCall;
